module.exports = __webpack_public_path__ + "img/9.3b6a00e7.png";